<template>
  <el-header id="header" style="text-align: right; font-size: 12px">
    <el-row type="flex">
      <el-col class="d-large-none" :xl="1" :lg="1" :md="1" :sm="1" :xs="2" v-if="windowSize < 1200">
        <div @click="toggleSidebar" class="togglerButton mt-4">
          <span class="top-icon-bar" :class="{'openedMenu':isCollapse}"></span>
          <span class="middle-icon-bar" :class="{'openedMenu':isCollapse}"></span>
          <span class="bottom-icon-bar" :class="{'openedMenu':isCollapse}"></span>
        </div>
      </el-col>
      <el-col :xl="4" :lg="4" :md="4" :sm="13" :xs="12">
        <div class="navbar-header">
          <router-link to="/dashboard">
            <img
              src="@/assets/9to5_50_leuko .png"
              style="object-fit:contain"
              alt="logo"
              class="float-left logoStyle mt-3"
            >
          </router-link>
        </div>
      </el-col>
      <el-col :xl="20" :lg="20" :md="17" :sm="7" :xs="5">
        <div class="mt-2 float-right">
          <el-autocomplete
            v-if="windowSize > 750"
            ref="searchInput"
            class="inline-input float-right mt-2 customSearchInput d-none"
            v-model="state2"
            :fetch-suggestions="querySearch"
            placeholder="Please Input"
            :trigger-on-focus="false"
            size="mini"
            @select="handleSelect"
          >
            <i class="mt-2 mr-2 el-icon-search" slot="suffix"></i>
          </el-autocomplete>
          <i v-else class="mt-2 mr-2 el-icon-search search d-none" slot="suffix"></i>
        </div>
      </el-col>
      <el-col :xl="1" :lg="2" :md="3" :sm="4" :xs="7">
        <el-row class="mt-3">
          <el-col :span="12">
            <el-dropdown trigger="click" @command="handleSetLanguage">
              <div class="flags mr-2" style="cursor: pointer">
                <img v-if="language === 'gr'" src="@/assets/images/gr.svg" class="round" alt="flag">
                <img
                  v-else-if="language === 'en'"
                  src="@/assets/images/en.svg"
                  class="round"
                  alt="flag"
                >
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="en" :disabled="language==='en'">
                  <img src="@/assets/images/en.svg" class="round flagIcon" alt="flag"> English
                </el-dropdown-item>
                <el-dropdown-item command="gr" :disabled="language==='gr'">
                  <img src="@/assets/images/gr.svg" class="round flagIcon" alt="flag"> Ελληνικά
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <el-col :span="12">
            <el-dropdown trigger="click">
              <span v-if="UserData.avatar">
                <img
                  :src="path(UserData.id, UserData.avatar)"
                  alt="profile"
                  class="profilePic rounded"
                >
              </span>
              <span
                v-else
                class="UserAvatar pointer"
              >{{getLetters(UserData.f_name, UserData.l_name)}}</span>
              <el-dropdown-menu slot="dropdown">
                <p class="loggedAs pl-2">{{$translation('Logged_in_as')}}</p>
                <p class="userName pl-2">{{this.UserData.f_name}}</p>
                <p
                  v-if="this.UserData.information && this.UserData.information.email"
                  class="userEmail pl-2"
                >{{this.UserData.information.email}}</p>
                <p class="pointer pl-2 d-none">
                  <svgicon
                    icon="profilesettings"
                    width="12"
                    height="12"
                    color="#2b2a29"
                    class="mr-2"
                  ></svgicon>Profile Settings
                </p>
                <p class="pointer pl-2 d-none">
                  <svgicon
                    icon="accountsettings"
                    width="12"
                    height="12"
                    color="#2b2a29"
                    class="mr-2"
                  ></svgicon>Account Settings
                </p>
                <div v-if="UserData.id === 1">
                  <hr class="mt-4">
                  <p class="usePortal">{{$translation('Use_portal_in_as')}}</p>
                  <!-- Select User submenu -->
                  <VuePerfectScrollbar class="userList">
                    <p
                      v-for="Employee in Employees.slice(0, this.EmployeesLimit) "
                      :key="Employee.id"
                      class="pointer"
                    >
                      <span v-if="Employee.avatar">
                        <img id="circleProfile" :src="path(Employee.id, Employee.avatar)" alt="av">
                      </span>
                      <span v-else class="circle">{{getLetters(Employee.f_name, Employee.l_name)}}</span>
                      {{Employee.f_name + ' ' + Employee.l_name}}
                    </p>
                  </VuePerfectScrollbar>
                  <p
                    v-if="this.EmployeesLimit === 4 && this.Employees.length > 4"
                    class="text-center viewAllUsers pointer"
                    @click="viewAll"
                  >{{$translation('View_all_users')}}</p>
                  <p
                    v-else-if="this.EmployeesLimit > 4"
                    class="text-center viewAllUsers pointer"
                    @click="viewLess"
                  >{{$translation('View_less_users')}}</p>
                </div>
                <!-- <el-select  v-model="value" :placeholder="$t('route.SelectUser')" v-if="this.UserData.id === 716" @change="changeProfile(value)">
                        <el-option
                        v-if="showMaster()"
                        label="Master"
                        value="master">
                        </el-option>
                        <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                </el-select>-->
                <!-- end of select user submenu -->
                <hr class="ml-1 mr-1">
                <p class="pl-2 mt-2 mb-2 pointer" @click="logout">
                  <svgicon icon="logout" width="10" height="10" color="#2b2a29" class="mr-2"></svgicon>
                  {{$translation('Log_out')}}
                </p>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-header>
</template>
<script>
import store from '@/store';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import '@/compiled-icons/';
import svgicon from 'vue-svgicon';
import { mapState } from 'vuex';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import { getHeader, LogoutLogApi, refreshToken } from '@/utils/echoApi';
export default {
  name: 'Header',
  components: {
    svgicon,
    VuePerfectScrollbar
  },
  data () {
    return {
      // token: [{
      //   access_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIzRWIweFVUYlVGY0pNMzJ4Vk9CUE9wIiwiaWF0IjoxNTMyNjA5Mjk4LCJleHAiOjE1MzI2MTI4OTgsInNjb3BlIjp7InR5cGUiOjMsImdyYW50X3R5cGUiOiJhY2Nlc3MiLCJjb250YWN0X2lkIjo1NDV9fQ.XjU3kqcmuJFwVQAgwrIfuVkGMLZDuPqNcYuKWbEGBpI',
      //   refresh_token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyaVVMVVQ0ZTF2aXUxVVBpbmRRVXFmIiwiaWF0IjoxNTMyNjA5Mjk4LCJleHAiOjE1MzM4MTg4OTgsInNjb3BlIjp7ImdyYW50X3R5cGUiOiJyZWZyZXNoIiwiY29udGFjdF9pZCI6NTQ1fX0.Y3udqFKojdR6xDQFZqBoYlUAgQAwUnZS1QaQ199jreg'
      // }],
      options: [
        {
          id: '1',
          label: 'Jimmys',
          value: [
            {
              access_token:
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIyNzB0aEI3T2RudGNPQWpaZUxSRGt3IiwiaWF0IjoxNTMyNjIxNDUxLCJleHAiOjE1MzI2MjUwNTEsInNjb3BlIjp7InR5cGUiOjMsImdyYW50X3R5cGUiOiJhY2Nlc3MiLCJjb250YWN0X2lkIjo1NDV9fQ.sKhQl2FAMAD1Je30OvMHnZm74Vl37rdcBVikXBclfC8',
              refresh_token:
                'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIzVmFKVHhyc0tuZnN0bWpzQkRrWXplIiwiaWF0IjoxNTMyNjIxNDUxLCJleHAiOjE1MzM4MzEwNTEsInNjb3BlIjp7ImdyYW50X3R5cGUiOiJyZWZyZXNoIiwiY29udGFjdF9pZCI6NTQ1fX0.ql3dZV-mKQTpwbCiulfkCBlFLWkAbJa-lQUAhveGJyk'
            }
          ]
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      value: '',
      // baseStyles: {
      //   background: 'linear-gradient(#275deg, #104e7f, #03a8fc)'
      // },
      links: [],
      state2: '',
      EmployeesLimit: 4
    };
  },
  computed: {
    language () {
      return this.$store.getters.getMyLang;
    },
    ...mapState('data', {
      Employees: state => state.Employees
    }),
    ...mapState('menu', {
      isCollapse: state => state.openedMenu
    }),
    ...mapState('window', {
      windowSize: state => state.size
    }),
    ...mapState('data', {
      UserData: state => state.UserData
    }),
    ...mapState('data', {
      tokenData: state => state.tokenData
    }),
    ...mapState('data', {
      masterTokenData: state => state.masterTokenData
    }),
    ...mapState('data', {
      localpath: state => state.hostname
    })
    // ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded'])
    // ...mapState({
    //   authLoading: state => state.auth.status === 'loading',
    //   name: state => `${state.user.profile.title} ${state.user.profile.name}`
    // })
  },
  methods: {
    handleSetLanguage (lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('setLanguage', lang);
      this.$store.dispatch('data/getMenus');
    },
    showMaster () {
      return localStorage.getItem('authBUser');
    },
    changeProfile (data) {
      // console.log(id[0].access_token)
      // alert(this.masterTokenData[0].access_token)
      if (data === 'master') {
        store.state.data.tokenData = JSON.parse(
          atob(localStorage.getItem('authBUser'))
        );
        if (this.$router.history.current.path === '/dashboard') {
          store.dispatch('data/getCalendarDates');
          store.dispatch('data/getMeetingData');
          store.dispatch('data/getAnnouncments');
        } else {
          this.$router.push('/dashboard');
        }
        localStorage.removeItem('authBUser');
      } else {
        if (!localStorage.getItem('authBUser')) {
          localStorage.setItem(
            'authBUser',
            btoa(JSON.stringify(this.tokenData))
          );
        }
        // alert(this.masterTokenData[0].access_token)
        store.state.data.tokenData = data[0];
        localStorage.setItem('authUser', btoa(JSON.stringify(data[0])));
        if (this.$router.history.current.path === '/dashboard') {
          store.dispatch('data/getCalendarDates');
          store.dispatch('data/getMeetingData');
          store.dispatch('data/getAnnouncments');
        } else {
          this.$router.push('/dashboard');
        }
      }
    },
    querySearch (queryString, cb) {
      var links = this.links;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    logout: function () {
      let data = {};
      this.$http
        .post('https://' + this.localpath + LogoutLogApi, data, {
          headers: getHeader()
        })
        .then(response => {
          this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'));
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 401) {
            refreshToken().then(resposne => {
              this.$http
                .post('https://' + this.localpath + LogoutLogApi, data, {
                  headers: getHeader()
                })
                .then(response => {
                  if (response.status === 201) {
                    // this.AddTaskForm.assignee = this.AddTaskForm.assigned_id[0]
                    // this.$store.commit('data/addNewTask', this.AddTaskForm)
                    this.$store
                      .dispatch(AUTH_LOGOUT)
                      .then(() => this.$router.push('/'));
                    // this.$router.push('/tickets')
                  }
                });
            });
          }
        });
    },
    // clear () {
    //   const input = this.$refs.searchInput
    //   alert(input.value)
    // },
    createFilter (queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    loadAll () {
      return [
        { value: 'files' },
        { value: 'dashboard' },
        { value: 'subscriptions' },
        { value: 'Upcoming Meetings', link: '/dashboard' },
        { value: 'Meetings', link: '/dashboard' },
        { value: 'Upcoming', link: '/dashboard' },
        { value: 'vue-router', link: 'https://github.com/vuejs/vue-router' },
        { value: 'about us', link: 'https://github.com/babel/babel' }
      ];
    },
    handleSelect (item) {
      // console.log(item.link)
      if (item.link) {
        this.$router.push(item.link);
      } else {
        this.$router.push(item.value);
      }
    },
    toggleSidebar () {
      this.$store.state.menu.openedMenu = !this.$store.state.menu.openedMenu;
      if (this.$store.state.menu.openedMenu === true) {
        this.$store.state.menu.overlay = true;
      } else {
        this.$store.state.menu.overlay = false;
      }
    },
    viewAll () {
      this.EmployeesLimit = this.Employees.length;
    },
    viewLess () {
      this.EmployeesLimit = 4;
    },
    getLetters (Fname, Lname) {
      if (typeof Fname !== 'undefined' && typeof Lname !== 'undefined') {
        var first = Fname.charAt(0);
        var second = Lname.charAt(0);
        return first + second;
      } else {
        window.location.reload();
      }
      //   alert(name.charAt(0))
    },
    path (id, avatar) {
      var exists =
        'https://' +
        this.localpath +
        '/echo/files/avatars/' +
        id +
        '.' +
        avatar;
      return exists;
    }
  },
  mounted () {
    this.links = this.loadAll();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.logoStyle {
  width: 138.6px;
  height: 29.4px;
  margin-top: 5px;
}
.el-popper[x-placement^="bottom"] {
  width: 229px;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y {
  background-color: var(--main-color);
}
.userList {
  overflow-y: scroll;
  max-height: 500px;
  p {
    font-size: 12px;
    color: #454545;
    padding-bottom: 5px;
  }
  p:hover,
  p:focus {
    background-color: var(--main-color);
    opacity: 0.7;
    color: #ffffff;
    width: 222px;
  }
}
.pointer:hover,
.pointer:focus {
  background-color: var(--main-color);
  opacity: 0.7;
  color: #ffffff;
  width: 222px;
}
#header {
  background-image: linear-gradient(
    273deg,
    var(--secondary-color),
    var(--main-color)
  );
  height: 65px;
  z-index: 1000;
  position: fixed;
  width: 100%;
  //  margin-bottom: 50px;
  .flags {
    height: 30px;
    width: 30px;
  }
}
.flagIcon {
  width: 20px;
  height: 20px;
  position: relative;
  top: 5px;
  right: 5px;
}
.loggedAs {
  font-size: 10px;
  font-style: italic;
  color: var(--main-color);
}
.usePortal {
  font-size: 10px;
  font-style: italic;
  color: var(--main-color);
  position: relative;
  // left: -13px;
}
.userName {
  font-size: 14px;
  color: #454545;
  margin-bottom: -10px !important;
}
.userEmail {
  font-size: 11px;
  color: #949494;
}
hr {
  height: 0.1px;
  opacity: 0.2;
  border: solid 1px #848483;
}
.viewAllUsers {
  font-size: 10px;
  font-style: italic;
  color: #454545;
  height: 20px;
  padding-top: 2px;
}
.navbar-brand {
  /*display: inline-block;*/
  img {
    border: 0;
    vertical-align: middle;
  }
}
.customSearchInput {
  width: 228px;
  height: 25px;
  input {
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    background-color: #ffffff45;
    border: transparent;
    color: #ffffff;
  }
}
.navbar-header {
  width: 255px;
  height: 100%;

  a {
    .navbar-brand {
      text-decoration: none;
      color: #fff;
      img {
        border: 0;
        vertical-align: middle;
      }
    }
  }
}
.togglerButton {
  cursor: pointer;
  background-color: transparent;
  border: transparent;
  &:hover {
    background-color: transparent;
  }
}
.search {
  font-size: 25px;
  color: #ffffff;
}
#circleProfile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  background: var(--main-color);
  position: relative;
  top: 6px;
  margin-right: 5px;
}
.circle {
  border-radius: 50%;
  font-size: 10px;
  color: #fff;
  padding: 5px;
  line-height: 47px;
  text-align: center;
  background: var(--main-color);
  margin-right: 5px;
}
.UserAvatar {
  border-radius: 50%;
  font-size: 16px;
  color: #fff;
  padding: 5px;
  line-height: 30px;
  text-align: center;
  background: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue